import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBanks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6001 39.4051V14.414C19.6001 13.7398 19.9238 13.1065 20.4704 12.7117L35.8704 1.58748C36.6045 1.05724 37.5957 1.05724 38.3298 1.58748L53.7298 12.7117C54.2763 13.1065 54.6001 13.7398 54.6001 14.414V39.4051C54.6001 40.5648 53.6599 41.5051 52.5001 41.5051H21.7001C20.5403 41.5051 19.6001 40.5648 19.6001 39.4051Z",
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 21L7 34.8L6.99999 52.9103C6.99999 53.0703 7.12968 53.2 7.28965 53.2L21.7 53.2L30.6833 53.2L45.9103 53.2C46.0703 53.2 46.2 53.0703 46.2 52.9103L46.2 21",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6006 4.28125L50.3997 20.6415",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.7998 20.6426L26.5989 4.2823",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 34.9995,
			y: 21,
			width: 7,
			height: 32.2,
			rx: 1.44828,
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1992,
			y: 21,
			width: 7,
			height: 32.2,
			rx: 1.44828,
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.3999,
			y: 21,
			width: 8.4,
			height: 32.2,
			rx: 1.44828,
			stroke: "#031839",
			strokeWidth: 2.1
		})
	]
});
export default SvgBanks;
